import { useTranslation } from "react-i18next"
import classes from "./NamePlateBg.module.css"

import Input from "../../components/UI/Input/Input"

import { nameplates, nameplatesShop } from "../../Utils"

export const NamePlateBG = props => {
    const [t] = useTranslation()
    return (
        <div className={classes.NameplateFullEntry}>
            {props.formless ? null : (
                <Input
                    type="checkbox"
                    title={t("translation:LayoutMsg.Cmn_CstBase_00.L_BtnList_08-T_SoldOut_00")}
                    val={props.owned}
                    labelClick={true}
                    changed={() => props.store(props.elem.Id)}
                />
            )}
            {props.fullSize ? (
                <img
                    src={`https://leanny.github.io/splat3/images/npl/${props.elem.__RowId}.png`}
                    alt={props.elem.__RowId}
                    className={classes.BannerImage}
                />
            ) : (
                <img
                    src={`https://leanny.github.io/splat3/images/npl/${props.elem.__RowId}.png`}
                    alt={props.elem.__RowId}
                    width={196}
                    className={classes.BannerImage}
                />
            )}
        </div>
    )
}

export const NamePlateBGList = props => {
    return [...nameplates]
        .sort((a, b) => (props.reverse ? b.Order - a.Order : a.Order - b.Order))
        .filter(k => !(props.showOnlyOwned ?? false) || props.owned[parseInt(k.Id)])
        .map((k, v) => <NamePlateBG store={props.store} elem={k} key={v} owned={props.owned[k.Id] ?? false} />)
}

export const get_nameplate_list = owned => {
    return nameplatesShop()
        .filter(k => !(owned[k.Id] ?? false))
        .map((k, v) => {
            return {
                value: v,
                label: k.__RowId,
                raw: k,
            }
        })
}
